// import React from 'react';
// import { BrowserRouter as Router } from 'react-router-dom';
// import AuthRoute from './authroute';
// import MainRoute from './mainroute';

// const Routes: React.FC = () => {
//   const isAuthenticated = sessionStorage.getItem('Token');
//   const isAuthenticatedUser = sessionStorage.getItem('UserTypeID');
//   return (
//     <>
//       {isAuthenticated ? <MainRoute /> : <AuthRoute />}
//     </>
//   );
// };

// export default Routes;
import React from 'react';
import AuthRoute from './authroute';
import MainRoute from './mainroute';
import { Customer } from '../helper/statusType';

const Routes: React.FC = () => {
  const isAuthenticated = sessionStorage.getItem('Token');
  const isCustomerUser = sessionStorage.getItem('UserTypeID');

  return (
    <>
      {isAuthenticated && isCustomerUser === Customer
        ? <AuthRoute />
        : isAuthenticated
          ? <MainRoute />
          : <AuthRoute />
      }
    </>
  );
};

export default Routes;